import React, { FC } from 'react'
import {
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
  Table,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core'

export const About: FC = () => {
  const classes = useStyles()

  return (
    <>
      <Grid container>
        <Grid item sm={4} classes={{ root: classes.introContainer }}>
          <Typography component='h5' variant='h5' className={classes.sectionTitle}>
            About the event.
          </Typography>
        </Grid>

        <Grid item sm={8} classes={{ root: classes.introContainer }}>
          <Typography paragraph>
            Defense agencies are looking for ways to become more agile with 5G in an effort to enhance their digital
            transformation initiatives and better support the warfighter.
            <br />
            <br />
            During this hour-long event, Verizon will explain why 5G matters to the DOD, how it can help securely shape
            missions, and discuss defense-focused use cases.
            <br />
            <br />
            Additionally, we discuss the path one military base took to deploy 5G and how it is being used to support
            their strategic initiatives.
          </Typography>
        </Grid>
      </Grid>
      <Grid container className={classes.eventAgendaContainer}>
        <Grid item xs={12} sm={4}>
          <Typography component='h5' variant='h5' className={classes.sectionTitle}>
            Event agenda.
          </Typography>
          <Typography paragraph className={classes.eventDate} style={{ lineHeight: 1.4 }}>
            February 24, 2021
            <br />
            2&nbsp;&nbsp;PM ET
          </Typography>
        </Grid>

        <Grid item xs={12} sm={8}>
          <Table className={classes.table}>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                      <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                        Verizon’s commitment to 5G
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <Typography paragraph className={classes.presenter}>
                        Tami Erwin - CEO, Verizon Business
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                      <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                        Verizon and the military
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <Typography paragraph className={classes.presenter}>
                        Andrés Irlando - SVP and President, Public Sector and Verizon Connect, Verizon
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                      <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                        Why 5G matters to the DOD
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <Typography paragraph className={classes.presenter}>
                        Jennifer Chronis - VP, Federal, Verizon
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                      <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                        What 5G technologies can do for the military
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <Typography paragraph className={classes.presenter}>
                        Mike Haberman - VP, Technology Development & Planning, Verizon Global Network & Technology
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                      <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                        5G and the U.S. Marine Corps: How Miramar is becoming a proving ground for new use cases
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                        Laurie Mulligan - Defense Client Partner, DoD, Verizon
                      </Typography>
                      <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                        Lt. Col. Brandon Newell - Director, SoCal Tech Bridge
                      </Typography>
                      <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                        Paul Guckian - VP Engineering, Qualcomm
                      </Typography>
                      <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                        Steve Lamb - Director, Network Field Engineering, Verizon
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell style={{ borderBottom: 0 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                      <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                        Closing remarks
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                        Cornelius Brown - Director, Department of Defense Sales, Verizon
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell style={{ borderBottom: 0 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                      <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                        DOD 5G use cases
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                        Geospatial data and analysis using drone services, <i>Aerial Applications</i>
                      </Typography>
                      <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                        How IoT solutions benefit the DOD, <i>Blueforce Development</i>
                      </Typography>
                      <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                        Immersive 5G AR/VR training, <i>Taqtile</i>
                      </Typography>
                      <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                        Augmented reality workforce solutions, <i>Vuzix</i>
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      overflowY: 'auto',
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    },
    eventAgendaContainer: {
      marginTop: theme.spacing(6)
    },
    introContainer: {
      marginTop: 13
    },
    agendaItemTitle: {
      fontSize: 18,
      marginBottom: 7,
      lineHeight: '16.8px'
    },
    presenter: {
      fontSize: 16,
      lineHeight: '19.15px',
      marginBottom: 10
    },
    multiPresenter: {
      marginBottom: 4
    },
    eventDate: {
      fontSize: 16,
      marginTop: 16
    },
    itemDetails: {
      fontSize: 14,
      lineHeight: '16.76px'
    },
    sectionTitle: {
      fontSize: 28,
      '&:after': {
        backgroundColor: '#d52b1e',
        content: '" "',
        height: 4,
        marginTop: theme.spacing(1),
        width: 32,
        display: 'block'
      }
    },
    table: {
      '& .MuiTableCell-root': {
        borderBottom: 'none',
        paddingLeft: 0
      }
    },
    tableSchedule: {
      minWidth: 210,
      verticalAlign: 'top'
    }
  })
)
